import { useState } from "react";
import { useData, useDispatch } from "./DataContext.js";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import { BsXLg } from "react-icons/bs";

import Dialog from "./Dialog.js";
import ImpactList from "./ImpactList.js";
import SolutionTitle from "./SolutionTitle.js";

export default function ReportApplicationModal (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    const [showGroupDialog, setShowGroupDialog] = useState(false);
    const [showMoneyDialog, setShowMoneyDialog] = useState(false);

    const moneyDialog = (
	<Dialog show={showMoneyDialog} hide={() => setShowMoneyDialog(false)} title="Fonds insuffisants">
	    <p>Vous n'avez malheureusement pas les fonds suffisants pour appliquer cette solution...</p>
	</Dialog>
    );


    const solutionId = gData.state.currentSolutionId;
    if (solutionId === null) return (<></>);

    const solution = gData.state.solutions[solutionId]
    const solutionContent = gData.content.solutions[solutionId]

    function closeReportApplication () { gDispatch({ type: "closeApplication" }); gDispatch({ type: "openReport" }); }
    function applySolution () { gDispatch({ type: "applySolution", solutionId }); }
    function rejectSolution () { gDispatch({ type: "rejectSolution", solutionId }); }

    let groupDialog = (<></>);
    let groupedSolutionIds = [];
    
    if (solutionContent.group !== null)
    {
	groupedSolutionIds = Object.values(gData.state.solutions)
				   .filter((groupedSolution) => {
				       const groupedSolutionContent = gData.content.solutions[groupedSolution.id];
				       return groupedSolutionContent.themeId === solutionContent.themeId && groupedSolution.id !== solutionId && groupedSolutionContent.group === solutionContent.group && groupedSolution.applied === null;
				   })
				   .map((solution) => solution.id);

	if (groupedSolutionIds.length > 0)
	{
	    groupDialog = (
		<Dialog show={showGroupDialog} hide={() => setShowGroupDialog(false)} confirm={applySolution} title="Appliquer la solution ?">
		    <p>Attention : si vous appliquez cette solution, vous ne pourrez pas appliquer {groupedSolutionIds.length === 1 ? "la solution suivante" : "les solutions suivantes"}&nbsp;:</p>
		    <div className="d-flex flex-wrap justify-content-center gap-2">{groupedSolutionIds.map((groupedSolutionId) => (<SolutionTitle key={groupedSolutionId} solutionId={groupedSolutionId}/>))}</div>
		</Dialog>
	    );
	}
    }
    
    function checkAndApplySolution ()
    {
	if (gData.content.solutions[solutionId].cost > 0 && gData.content.solutions[solutionId].cost > gData.state.money) setShowMoneyDialog(true)
	else if (groupedSolutionIds.length > 0) setShowGroupDialog(true);
	else applySolution();
    }

    return (
	<>
	    <Modal
		dialogClassName="modal-md2"
				 show={gData.state.showModals.application}
				 onHide={closeReportApplication}
				 backdropClassName="backdrop-second"
				 centered
	    >
		<Modal.Header className="d-flex align-items-center justify-content-between bg-light">
		    <div>
			<SolutionTitle solutionId={solutionId} size="md"/>
			{/* <span className="fs-5">Prise de décision</span> */}
		    </div>
		    <Button variant="secondary" onClick={closeReportApplication}><BsXLg/></Button>
		    {/* <div className="d-flex gap-2">
			{solution.applied !== null && (<ApplicationBadge solutionId={solution.id}/>)}
			{solution.applied === null && (
			<>
			<Button variant="primary" onClick={checkAndApplySolution}>Appliquer</Button>
			<Button variant="primary" onClick={rejectSolution}>Rejeter</Button>
			</>
			)}
			<Button variant="secondary" onClick={closeReportApplication}><BsXLg/></Button>
			</div> */}
		</Modal.Header>
		<Modal.Body>
		    <div className="d-flex justify-content-between align-items-center gap-5">
			<div className="flex-fill text-center">
			    <div className="text-uppercase fs-5 fw-medium">État de l'entreprise</div>
			    <ImpactList solutionId={solution.id} type="inter-result"/>
			</div>
			<div className="text-center">
			    <div className="text-uppercase fs-5 fw-medium">Impacts estimés</div>
			    <ImpactList solutionId={solution.id} type="analysis"/>
			</div>
		    </div>
		    {solution.applied === null && (
			<div className="mt-4 d-flex justify-content-center gap-2">
			    <Button variant="primary" onClick={checkAndApplySolution}>Appliquer la solution</Button>
			    <Button variant="primary" onClick={rejectSolution}>Rejeter la solution</Button>
			</div>
		    )}
		    {solution.applied !== null && (
			<div className="mt-4 d-flex justify-content-center gap-2">
			    <Button variant="primary" className="opacity-0">Text</Button>
			</div>
		    )}
		</Modal.Body>
	    </Modal>
	    {groupDialog}
	    {moneyDialog}
	</>
    );
}
